export enum StreamType {
  Building = 0,
  Edge = 1,
}
